import React, { useState } from "react";
import { Accordion, Badge, Button, Card, Collapse, Row, Col } from "react-bootstrap";
import StopTimetable from "./StopTimetable.jsx";
import { AppLink } from "../../services/goTo.jsx";

function sortDays(stopTimes) {
  const order = [
    "weekdays", "weekends", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday",
  ];
  const normalize = s => s.replace(/\s+/g, "").toLowerCase();
  return [...stopTimes].sort((a, b) => {
    const aIdx = order.indexOf(normalize(a[0]));
    const bIdx = order.indexOf(normalize(b[0]));
    if (aIdx === -1 && bIdx === -1) return 0;
    if (aIdx === -1) return 1;
    if (bIdx === -1) return -1;
    return aIdx - bIdx;
  });
}

function normalizeServiceLabel(service) {
  return String(service || "")
    .replace(/_/g, " & ")
    .split(/\s+/)
    .map((word) => {
      if (word === "&") return word;
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}

export default function StopRoute({ route }) {

  const [activeKey, setActiveKey] = useState("");
  const isOpen = activeKey === "0";
  if (!route) {
    return null;
  }

  const directions = Object.values(route.directions || {});

  const routeLink = `/plan-your-trip/routes/${route.route_short_name}`;

  return (
    <Col xs={12} className="mb-3">
      <Accordion activeKey={activeKey} onSelect={setActiveKey}>
        <Accordion.Item eventKey="0">
          <Accordion.Header as="h4">
            Route {route.route_short_name} - {route.route_long_name && <> {route.route_long_name}</>}
            <i
              className={`fas ${isOpen ? "fa-chevron-up" : "fa-chevron-down"}`}
              aria-hidden="true"
            />
          </Accordion.Header>

          <Accordion.Body className="px-3 py-5">

            {directions.map((direction, directionIndex) => {
              const stopTimes = Object.entries(direction.stop_times || {});

              return (
                <div key={directionIndex} className="mb-3">
                  <h5>
                    To {direction.trip_headsign}
                    {direction.trip_headsign_description && (
                      <> - {direction.trip_headsign_description}</>
                    )}
                  </h5>

                  {stopTimes.length === 0 ? (
                    <div>No stop times.</div>
                  ) : (
                    sortDays(stopTimes).map(([service, times]) => {
                      const key = `${directionIndex}-${service}`;
                      const timeArr = Array.isArray(times)
                        ? times
                        : Object.values(times || {});
                      const normalizedService = normalizeServiceLabel(service);

                      return (
                        <div key={key} className="mb-2">
                          <StopTimetable times={timeArr} service={normalizedService} />
                        </div>
                      );
                    })
                  )}
                </div>
              );
            })}


            <p>
              <AppLink to={routeLink}>
                View
                all details for Route</AppLink>{" "}
              <AppLink to={routeLink}><Badge>{route.route_short_name}</Badge>
              </AppLink>
              .
            </p>

          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Col>
  );
}
